import React, { useMemo, useState } from 'react'

import { QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import UnknownProductsList from '@shared/unknown_products/UnknownProductsList'
import OperatorUnknownProductConceptModal from '@shared/unknown_products/OperatorUnknownProductConceptModal'
import ListPageHeader from '@shared/ListPageHeader'

import { unknownProductService } from '@services/operator/unknownProductService'

export default function OperatorUnknownProductsList() {
  const { t } = useTranslation()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.unknown']}
        guideButton={
          <Tooltip title={t('concepts.unknown_products_operator.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
      />
      <UnknownProductsList
        role="operator"
        service={unknownProductService}
        showMerchantColumn={!isStandard}
        merchants={merchantOptions}
      />
      <OperatorUnknownProductConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
